var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_4450",
    "data-name": "Groupe 4450",
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.64,
    height: 36.821,
    viewBox: "0 0 43.64 36.821",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4474",
    "data-name": "Trac\\xE9 4474",
    d: "M31.429,5.392A18.411,18.411,0,1,0,5.392,31.429,18.411,18.411,0,1,0,31.429,5.392m-11.74,28.82V32.986a1.279,1.279,0,1,0-2.557,0v1.227A15.88,15.88,0,0,1,2.609,19.689H3.836a1.279,1.279,0,0,0,0-2.557H2.609A15.88,15.88,0,0,1,17.132,2.609V3.836a1.279,1.279,0,1,0,2.557,0V2.609A15.88,15.88,0,0,1,34.213,17.132H32.986a1.279,1.279,0,1,0,0,2.557h1.227A15.88,15.88,0,0,1,19.689,34.213",
    fill: "#202b53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4475",
    "data-name": "Trac\\xE9 4475",
    d: "M403.826,4.862h1.924a1.279,1.279,0,0,0,0-2.557h-4.773A1.278,1.278,0,0,0,399.7,3.584V8.357a1.279,1.279,0,1,0,2.557,0V7.011a22.682,22.682,0,0,1-2.183,29.54,1.279,1.279,0,1,0,1.808,1.808,25.233,25.233,0,0,0,1.945-33.5",
    transform: "translate(-365.63 -2.109)",
    fill: "#202b53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4476",
    "data-name": "Trac\\xE9 4476",
    d: "M134.559,139.331l-8.018,3.739a3.828,3.828,0,0,0-5.47,0l-4.036-1.882a1.278,1.278,0,1,0-1.08,2.317l4.034,1.881q-.018.183-.018.37a3.836,3.836,0,0,0,7.671,0q0-.187-.018-.37l8.016-3.738a1.279,1.279,0,1,0-1.081-2.318m-10.752,7.7a1.279,1.279,0,1,1,1.279-1.279,1.28,1.28,0,0,1-1.279,1.279",
    transform: "translate(-105.397 -127.345)",
    fill: "#202b53"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/history-icon.e3ae45037c28cda993c594e39f159253.svg";
export { ForwardRef as ReactComponent };